import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { css as _css } from "@emotion/react";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from 'react';
import { useTheme } from '@emotion/react';
import clsx from 'clsx';
import { text } from '../assets/styles/utility';
import Close from './Close';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesAlertBase = theme => [{
  borderLeft: '8px solid transparent',
  color: theme.fontColor.base,
  borderRadius: theme.borderRadius.base,
  padding: theme.space.base,
  position: 'relative',
  [theme.mq.medium]: {
    padding: theme.space.large
  },
  'a:not([class]), a[class=""], .u-link': [text.underline, {
    color: 'currentColor',
    '&:hover, &:focus': {
      color: 'currentColor'
    }
  }]
}];
export const StylesAlertDefault = theme => ({
  borderColor: theme.color.border.base,
  background: theme.color.panel.base
});
export const StylesAlertPrimary = theme => ({
  borderColor: theme.color.primary.base,
  background: theme.color.primary.light
});
export const StylesAlertWarning = theme => ({
  borderColor: theme.color.warning.base,
  background: theme.color.warning.light
});
export const StylesAlertDanger = theme => ({
  borderColor: theme.color.danger.base,
  background: theme.color.danger.light,
  '.CK__Alert__Title, .CK__Alert__Close': {
    color: theme.color.danger.base
  }
});

const Alert = _ref => {
  let {
    children,
    className,
    reveal,
    setReveal,
    title,
    type = 'default'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["children", "className", "reveal", "setReveal", "title", "type"]);

  const theme = useTheme();
  const ref = React.useRef();
  if (!reveal && typeof setReveal === 'function') return null;
  return ___EmotionJSX("div", _extends({
    css: [StylesAlertBase(theme), type === 'default' && StylesAlertDefault(theme), type === 'primary' && StylesAlertPrimary(theme), type === 'warning' && StylesAlertWarning(theme), type === 'danger' && StylesAlertDanger(theme), process.env.NODE_ENV === "production" ? "" : ";label:Alert;"],
    className: clsx('CK__Alert', className),
    role: "alert",
    ref: ref
  }, rest), ___EmotionJSX("div", {
    className: `CK__Alert__Content ${theme.settings.classes.trim}`
  }, title && ___EmotionJSX("div", {
    css: /*#__PURE__*/_css(_objectSpread(_objectSpread({}, theme.text.xlarge__fluid), {}, {
      fontWeight: theme.fontWeight.bold,
      marginBottom: theme.space.base
    }), process.env.NODE_ENV === "production" ? "" : ";label:Alert;"),
    className: "CK__Alert__Title"
  }, title), children), typeof setReveal === 'function' && ___EmotionJSX(Close, {
    css: /*#__PURE__*/_css({
      position: 'absolute',
      top: theme.space.small,
      right: theme.space.small,
      zIndex: 1,
      [theme.mq.medium]: {
        top: theme.space.base,
        right: theme.space.base
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:Alert;"),
    className: "CK__Alert__Close",
    onClick: () => setReveal(false)
  }));
};

export default Alert;